import { render, staticRenderFns } from "./ques-steps.vue?vue&type=template&id=4c170442&scoped=true&"
import script from "./ques-steps.vue?vue&type=script&lang=js&"
export * from "./ques-steps.vue?vue&type=script&lang=js&"
import style0 from "./ques-steps.vue?vue&type=style&index=0&id=4c170442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c170442",
  null
  
)

export default component.exports